module.exports = __webpack_public_path__ + "static/media/19.6b75c389.jpg";